import { login, getInfo } from "@/api/user";
import { Toast } from "vant";
import router from "@/router";
import { createStore } from "vuex";
import Cookies from "js-cookie";
import { RegisterWy, getWyToken } from "@/api/chat";
import { setToken, getToken, removeToken } from "@/utils/auth";
import { initIm } from "../utils/imtools";
import { userLogin } from "@/api/im.js";
import md5 from "js-md5";
export default createStore({
  state: {
    token: "",
    username: "",
    // avatar: "https://pic3.zhimg.com/v2-fe127aac97845744e7b2124ffe16df6d_r.jpg",
    avatar: "",
    id: "",
    isrealname: "",
    nicename: "",
    realname: "",
    coinShowType: "",
    appKey: "7de98791c71bd7eb5ef7ac32c532e73d",
    wyAccount: "",
    wyToken: "",
    // 悟空聊天
    imtoken: "",
    imuid: "",
    conversationWraps: [],
  },
  mutations: {
    // 设置token
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    // 设置用户名
    SET_NAME: (state, name) => {
      state.username = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ID: (state, id) => {
      state.id = id;
    },
    SET_ISREALNAME: (state, isrealname) => {
      state.isrealname = isrealname;
    },
    SET_NICENAME: (state, nicename) => {
      state.nicename = nicename;
    },
    SET_ISCOLLECT: (state, iscollect) => {
      state.iscollect = iscollect;
    },
    SET_GETGOOD: (state, getgood) => {
      state.getgood = getgood;
    },
    SET_FANS: (state, fans) => {
      state.fans = fans;
    },
    SET_COLLECT: (state, collect) => {
      state.collect = collect;
    },
    SET_GOLD: (state, gold) => {
      state.gold = gold;
    },
    SET_PTB: (state, ptb) => {
      state.ptb = ptb;
    },
    SET_CASH: (state, cash) => {
      state.cash = cash;
    },
    SET_SUPERMEMBERLEVEL: (state, supermemberlevel) => {
      state.supermemberlevel = supermemberlevel;
    },
    SET_WEIDU: (state, weidu) => {
      state.weidu = weidu;
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile;
    },
    SET_ID_CARD: (state, id_card) => {
      state.id_card = id_card;
    },
    SET_REALNAME: (state, realname) => {
      state.realname = realname;
    },
    SET_CPSNAME: (state, cpsname) => {
      state.cpsname = cpsname;
    },
    SET_HSD: (state, userhsd) => {
      state.userhsd = userhsd;
    },
    SET_MOUTHCARD: (state, monthcard) => {
      state.monthcard = monthcard;
    },
    SET_MOUTHCARD_EXPIRY_TIME: (state, monthcard_expiry_time) => {
      state.monthcard_expiry_time = monthcard_expiry_time;
    },
    SET_SAVINGCARD_EXPIRY_TIME: (state, savingcard_expiry_time) => {
      state.savingcard_expiry_time = savingcard_expiry_time;
    },
    SET_QQ: (state, qq) => {
      state.qq = qq;
    },
    SET_COIN_SHOW_TYPE: (state, coinShowType) => {
      state.coinShowType = coinShowType;
    },
    SET_TXMONEY: (state, txmoney) => {
      state.txmoney = txmoney;
    },

    // 设置网易云信账号
    SET_WYACCOUNT: (state, wyAccount) => {
      state.wyAccount = wyAccount;
    },
    // 设置网易云信token
    SET_WYTOKEN: (state, wyToken) => {
      state.wyToken = wyToken;
    },
  },
  actions: {
    login({ commit }, userInfo) {
      const { username, password } = userInfo;
      return new Promise((resolve, reject) => {
        login({
          username: username.trim(),
          password: password,
        })
          .then((response) => {
            console.log(response);
            const { data } = response;
            if (data.a == "-1") {
              Toast(data.b);
            } else {
              commit("SET_TOKEN", data.data.token);
              setToken(data.c.token);
              Cookies.set("password", password, {
                expires: 7,
              });
              Toast("登录成功");
              //router.back();
              router.push("/personal-page");
            }
            // commit();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    getInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        state;
        getInfo({
          uid: localStorage.getItem("uid"),
        })
          .then((response) => {
            // console.log("用户个人信息-----------", response);
            const { data } = response;
            if (!data || data.a < 1) {
              commit("SET_TOKEN", "");
              setToken("");
              // Toast("验证失败，请重新登录。");
            }
            console.log("gmh" ,data);
            if (data.code == 1) {
              commit("SET_TOKEN", getToken());
              commit("SET_NAME", data.data.username);
              commit("SET_AVATAR", data.data.avatar);
              commit("SET_ID", data.data.id);
              localStorage.setItem("uid", data.data.id);
              localStorage.setItem("username", data.data.username);
              // Toast(data.c.id);
              commit("SET_ISREALNAME", data.data.isrealname);
              commit("SET_NICENAME", data.data.nicename);
              commit("SET_ISCOLLECT", data.data.iscollect);
              commit("SET_GETGOOD", data.data.getgood);
              commit("SET_FANS", data.data.fans);
              commit("SET_COLLECT", data.data.collect);
              commit("SET_GOLD", data.data.gold);
              commit("SET_PTB", data.data.money);
              commit("SET_CASH", data.data.cash);
              commit("SET_SUPERMEMBERLEVEL", data.data.supermemberlevel);
              commit("SET_WEIDU", data.data.weidu);
              commit("SET_MOBILE", data.data.mobile);
              commit("SET_ID_CARD", data.data.id_card);
              commit("SET_REALNAME", data.data.realname);
              commit("SET_CPSNAME", data.data.cpsname);
              commit("SET_HSD", data.data.userhsd);
              commit("SET_QQ", data.data.qq);
              commit("SET_MOUTHCARD", data.data.monthcard);
              commit(
                "SET_MOUTHCARD_EXPIRY_TIME",
                data.data.monthcard_expiry_time
              );
              commit(
                "SET_SAVINGCARD_EXPIRY_TIME",
                data.data.savedcard_expiry_time
              );
              commit("SET_TXMONEY", data.data.txmoney);
              commit("SET_WYACCOUNT", data.data.username);
            }
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    
    // 链接im
    onIm({ state, commit }) {
      return new Promise(async (resolve, reject) => {
        console.log("获取im登录用户信息");
        userLogin({
          username: "zksq_" + state.username,
          password: md5(state.username),
          flag: 1,
          // "avatar":store.state.avatar,
          // "nickname":store.state.nicename,
          // "level":store.state.level?store.state.level:0,
          avatar: state.avatar,
          nickname: state.nicename,
          level: state.level || 0,
        })
          .then((data) => {
            initIm(data.data.token,data.data.uid);
            resolve();
          })
          .catch((error) => {
            Toast(error.msg);
            reject(error);
          });
      });
    },

    // // 用户登出
    loginout({
      commit,
      // state
    }) {
      return new Promise((resolve) => {
        // logout(state.token).then(() => {
        commit("SET_TOKEN", "");
        removeToken(); // 必须先删除令牌
        resolve();
        commit("SET_TOKEN", getToken());
        commit("SET_NAME", "");
        commit("SET_AVATAR", "");
        commit("SET_ID", "");
        commit("SET_ISREALNAME", "");
        commit("SET_NICENAME", "");
        commit("SET_ISCOLLECT", "");
        commit("SET_GETGOOD", "");
        commit("SET_FANS", "");
        commit("SET_COLLECT", "");
        commit("SET_GOLD", "");
        commit("SET_PTB", "");
        commit("SET_SUPERMEMBERLEVEL", "");
        commit("SET_WEIDU", "");
        commit("SET_MOBILE", "");
        commit("SET_ID_CARD", "");
        commit("SET_REALNAME", "");
        // }).catch(error => {
        //   reject(error)
        // })
      });
    },

    // 注册网易聊天
    async registerIM({ commit, wytoken }) {
      wytoken;
      try {
        let res = await RegisterWy({
          username: this.state.username,
          avatar: this.state.avatar,
          nicename: encodeURI(this.state.nicename),
          uid: this.state.id,
        });
        console.log("网易注册接口-----", res);
        let data = res.data;
        if (!data || data.code < 1) {
          commit("SET_WYTOKEN", "");
          localStorage.setItem("WyToken", "");
        }
        if (data.code == 1) {
          commit("SET_WYTOKEN", data.data);
          localStorage.setItem("WyToken", data.data);
        }
      } catch (error) {
        console.log(error);
      }
      // });
    },

    // 获取网易token
    async getImToken({ commit, wytoken }) {
      try {
        let res = await getWyToken({
          username: this.state.username,
          uid: this.state.id,
        });
        let data = res.data;
        if (!data || data.code < 1) {
          await this.dispatch("registerIM");
        }
        if (data.code == 1) {
          commit("SET_WYTOKEN", data.data);
          localStorage.setItem("WyToken", data.data);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  modules: {},
});
